import { render, staticRenderFns } from "./plugStyle.vue?vue&type=template&id=7048e164&scoped=true"
import script from "./plugStyle.vue?vue&type=script&lang=js"
export * from "./plugStyle.vue?vue&type=script&lang=js"
import style0 from "./plugStyle.vue?vue&type=style&index=0&id=7048e164&prod&lang=scss&scoped=true"
import style1 from "./plugStyle.vue?vue&type=style&index=1&id=7048e164&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7048e164",
  null
  
)

export default component.exports